/* eslint-disable max-len */
import * as R from 'ramda';

export default function AssignPRAAssetDialogController(
  $q,
  $rootScope,
  $scope,
  $filter,
  copy,
  ssDialogService,
  alerts,
  loaderService,
  praDataService,
  riskSharedModelService,
  assetSharedModelService,
  editAssetDialog,
  praSharedModelService
) {
  const vm = this;

  vm.handleCloseDialogClick = _handleCloseDialogClick;
  vm.handleAssignAssetSubmit = _handleAssignAssetSubmit;
  vm.handleAddAssetDialogClick = _handleAddAssetDialogClick;

  _activate();

  // //////// METHODS //////////

  function _activate() {
    const dfdActivate = $q.defer();
    initEventListeners();
    transformAssetList();
    dfdActivate.resolve();
  }


  function initEventListeners() {
    $scope.$on('refreshAssignAssets', () => {
      _refreshAssetTypes();
    });
  }

  function _handleCloseDialogClick() {
    ssDialogService.hide(ssDialogService.dialogs.pra.assignAssetDialog);
  }

  function _handleAssignAssetSubmit() {
    if ($scope.assignAssetForm.$valid) {
      loaderService.showViewLoader = true;
      const assetIds = getSelectedIds();
      praDataService.assignAssetsToProcess(vm.process.assessmentProcessId, assetIds).then((response) => {
        if (!response.data) {
          alerts.error('Error occurred while saving the asset for process.');
        } else {
          alerts.success('The assets for process has been saved successfully.');
          vm.saved = true;
          $rootScope.$broadcast('refreshAssessmentProcess', { process: vm.process });
          $rootScope.$broadcast('refreshMainAssessmentProcess', { process: vm.process });
          ssDialogService.hide(ssDialogService.dialogs.pra.assignAssetDialog);
        }
        loaderService.showViewLoader = false;
      });
    }
  }

  function getSelectedIds() {
    const assetTypes = vm.assetTypesIT.concat(vm.assetTypesNonIT);
    const openIds = [];
    const selectedIds = [];
    R.forEach((assetType) => {
      R.forEach((item) => {
        if (item.isAssigned === true) {
          selectedIds.push(item.customerAssetId);
        }
        openIds.push(item.customerAssetId);
      }, assetType.customerAssets);
    }, assetTypes);

    if (vm.assignedAssets && vm.assignedAssets.length > 0) {
      R.forEach((asset) => {
        const isOpen = openIds.includes(asset.customerAssetId);
        const isSelected = selectedIds.includes(asset.customerAssetId);
        if (!isOpen && !isSelected) {
          selectedIds.push(asset.customerAssetId);
        }
      }, vm.assignedAssets);
    }

    return selectedIds;
  }

  function _handleAddAssetDialogClick($event) {
    loaderService.showViewLoader = true;
    const asset = { customerAssetId: 0 };
    ssDialogService.dialogs.assetAdmin.editAssetDialog = ssDialogService.alert(
      editAssetDialog.getOptions($event, {
        asset,
        assetCriticalities: assetSharedModelService.AssetCriticalities,
        assetDataTypes: assetSharedModelService.AssetDataTypes,
        assetDataUses: assetSharedModelService.AssetDataUses,
        assetTypes: assetSharedModelService.AssetTypes,
      })
    );
    loaderService.showViewLoader = false;
    ssDialogService.show(ssDialogService.dialogs.assetAdmin.editAssetDialog);
  }

  function _refreshAssetTypes() {
    return praSharedModelService._initPage(true).then(() => {
      vm.assetTypes = assetSharedModelService.AssetTypes;
      transformAssetList();
    });
  }

  function transformAssetList() {
    const assetTypes = vm.assetTypes.map(assetType => ({
      ...assetType,
      customerAssets: [...assetType.customerAssets],
    }));

    R.forEach((assetType) => {
      assetType.attached = 0;
      assetType.assignedAssets = [];
    }, assetTypes);

    if (vm.assignedAssets && vm.assignedAssets.length > 0) {
      R.forEach((asset) => {
        const find = R.find(
          R.propEq('customerAssetTypeId', asset.customerAssetTypeId),
          assetTypes
        );
        if (find) {
          find.attached += 1;
          find.assignedAssets.push(asset);
        }
      }, vm.assignedAssets);
    }

    vm.assetTypesIT = $filter('filter')(
      assetTypes,
      { isITAsset: true }
    );

    vm.assetTypesNonIT = $filter('filter')(
      assetTypes,
      { isITAsset: false }
    );
  }
}

AssignPRAAssetDialogController.$inject = [
  '$q',
  '$rootScope',
  '$scope',
  '$filter',
  'copy',
  'ssDialogService',
  'alerts',
  'loaderService',
  'praDataService',
  'riskSharedModelService',
  'assetSharedModelService',
  'editAssetDialog',
  'praSharedModelService',
];
